/**
 * GroupGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * GroupGetReq
 */
export interface GroupGetReq {
  /** 群组ID，逗号分隔 */
  id: string
  /** 群组类型(camp/battle)，不传则自动检测 */
  type?: string
}

/**
 * GroupGetReq Schema
 */
export const GroupGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '群组ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '群组ID',
    },
    type: {
      description: '群组类型(camp/battle)，不传则自动检测',
      format: 'cons.GroupType',
      type: 'string',
      label: '群组类型',
    },
  },
  required: ['id'],
  type: 'object',
}
